














import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({})
export default class Radio extends Vue {
  @Prop({ required: true }) readonly radioId!: string;
  @Prop({ required: true }) readonly name!: string;
  @Prop({ required: false }) checked: boolean | undefined;

  passThroughChangeEvent (event: Event) {
    const target = event.target as HTMLInputElement
    this.$emit('update:checked', target.checked)
  }
}
